import { ChatUserFormData } from "shared/api";
import { getLocalStorageValue, getUserDataStorageKey } from "shared/functions";
import { AppConfiguration } from "shared/types";

import { createIntegrationData, getIntegrationConfigs } from "./utils";

import { IntegrationHandler } from ".";

type CalendlyUserData = {
  dateFrom: string;
  dateTo: string;
  name: string;
};

const perseChatUserData = (identifiedData: string): ChatUserFormData | null => {
  try {
    return JSON.parse(identifiedData);
  } catch {
    return null;
  }
};

export class CalendlyIntegrationHandler extends IntegrationHandler {
  constructor(options: IntegrationHandler) {
    super(options);
    Object.assign(this, options);
  }

  async run(
    onIntegrationClick: (integration: IntegrationHandler) => Promise<void>,
    config: AppConfiguration,
    botId: string,
  ): Promise<void> {
    const currentDate = new Date();
    const oneMonthFromNow = new Date(currentDate.getTime());
    oneMonthFromNow.setMonth(currentDate.getMonth() + 1);
    const resp = await getIntegrationConfigs({
      id: this.id,
      config,
      bot_id: botId,
    });
    let name = "Customer";
    const identifiedData = getLocalStorageValue(
      getUserDataStorageKey(config.instanceName, botId),
    );

    if (!!identifiedData) {
      const identifiedUser = perseChatUserData(identifiedData);
      if (identifiedUser !== null && identifiedUser.data_values) {
        const nameData = identifiedUser.data_values.find(
          data => data.key === "name",
        );

        name = nameData ? nameData.value : "Customer";
      }
    }

    // sameData is currently static data that we're passing from widget later this will be configurable by the admin.
    //this is required for the paragon workflow
    const sampleData: CalendlyUserData = {
      dateFrom: currentDate.toISOString(),
      dateTo: oneMonthFromNow.toISOString(),
      name,
    };

    //we're validating the data that we're getting from the widget and creating a new object with the data that we need.
    this.data = createIntegrationData(resp.widget_fields, sampleData);
    await onIntegrationClick(this);
  }
}
